export const VERSION = {
  name: 'GiA',
  fullName: 'Guia Inteligente do Autismo',
  vendor: 'TEA IA',
  version: '1.0.0',
  build: '20260208'
};

export const getVersionString = () => {
  return `${VERSION.name} v${VERSION.version} - Build ${VERSION.build} - ${VERSION.vendor}`;
};
